import React from 'react';

import { ThemedText } from '@/components/themed-text';
import { PACK_LOCATION_MODE } from '@/types/activity-pack';
import { WidgetCard } from './widget-card';
import { LocationWidgetData, WidgetProps } from './widget-types';

const ICON_BY_MODE: Record<PACK_LOCATION_MODE, 'storefront-outline' | 'car-outline' | 'videocam-outline'> = {
  [PACK_LOCATION_MODE.PROVIDER_SPACE]: 'storefront-outline',
  [PACK_LOCATION_MODE.CLIENT_ADDRESS]: 'car-outline',
  [PACK_LOCATION_MODE.ONLINE]: 'videocam-outline',
};

/** Onde o atendimento acontece. */
export function LocationWidget({ data }: WidgetProps<LocationWidgetData>) {
  return (
    <WidgetCard
      title="Onde você atende"
      icon={ICON_BY_MODE[data.mode] ?? 'location-outline'}
    >
      <ThemedText className="text-sm text-foreground/70">{data.label}</ThemedText>
      {data.address ? (
        <ThemedText className="text-xs text-foreground/45">
          {data.address}
        </ThemedText>
      ) : null}
    </WidgetCard>
  );
}
